export default function getBaseUrl() {
  // dev: include the port (window.location.host) so /api/ hits the vite proxy on the
  // current origin, not port 80. prod uses the standard https port.
  const { hostname, host } = window.location;
  return hostname.endsWith('.localhost')
    ? `http://${host}/api/dev`
    : `https://${hostname}/api/prod`;
}
